import React from "react";
import Select from "react-select";

const options = [
  { value: "exemplue", label: "Exemplu de eveniment" },
  { value: "exemplu2", label: "Exemplu de eveniment 2" },
  { value: "exemplu3", label: "Exemplu de eveniment 3" },
];

const CategorySelect = () => {
  return (
    <Select
      options={options}
      placeholder="Alege categoria"
      styles={{
        control: (base, state) => ({
          ...base,
          height: 42,
          width: "100%",
          backgroundColor: "",
          color: "white",
          boxSizing: "border-box",
          borderRadius: 20,
          border: "none",
          fontWeight: "normal",
          fontFamily: "Archivo",
          boxShadow: state.isFocused ? "none" : base.boxShadow,
          outline: "none",
        }),

        input: (base) => ({
          ...base,
          color: "white",
          fontSize: 14,
          border: "none",
          height: "100%", // Face input-ul să ocupe toată înălțimea control-ului
          padding: 0, // Elimină padding-ul default al input-ului
          margin: 0, // Elimină marginile implicite
          fontWeight: "normal",
          fontFamily: "Archivo",
        }),
        placeholder: (base) => ({
          ...base,
          color: "white",
          fontSize: 14,
          fontWeight: "normal",
          fontFamily: "Archivo",
        }),
      }}
    />
  );
};

export default CategorySelect;
